module.exports = __webpack_public_path__ + "assets/img/activity-time-c6e0a8f7.png";